var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgStepHeaderComplete = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.6693L14.3011 14.5201C14.7894 14.8862 15.4772 14.8143 15.8791 14.3551L23.3333 5.83594",
    stroke: "#6664E2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14C24.5 16.1939 23.8128 18.3327 22.5349 20.116C21.257 21.8994 19.4525 23.2376 17.3752 23.9428C15.2977 24.6479 13.0515 24.6847 10.952 24.0479C8.85257 23.411 7.00536 22.1325 5.66979 20.3921C4.33423 18.6515 3.57741 16.5363 3.50562 14.3436C3.43384 12.1508 4.0507 9.99068 5.26957 8.16652C6.48844 6.34235 8.24809 4.94579 10.3014 4.17299C12.3547 3.40018 14.5985 3.28996 16.7176 3.85778",
    stroke: "#6664E2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStepHeaderComplete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/step-header-complete.594dd492.svg";
export { ForwardRef as ReactComponent };